<style lang="less" scoped>
.abs-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.aboutus-container {
  background-color: #262c3e;
  // background: #262c3e url('~@/assets/map-1.png') no-repeat center;
}
.in-sec {
  width: 1200px;
  height: 606px;
  margin: 0 auto;
  padding: 0;
  color: #fff;
  font-size: 13px;
  position: relative;
}
h2 {
  color: #fff;
  font-size: 28px;
  position: relative;
  padding-top: 95px;
  padding-bottom: 22px;
  &::after {
    content: "";
    width: 18px;
    height: 2px;
    background-color: #1170fe;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
.txt {
  color: #fff;
  font-size: 15px;
  line-height: 200%;
  padding-top: 16px;
  font-family: "NotoSansKR_L";
}
.address {
  padding: 63px 0 30px 0;
  p {
    line-height: 220%;
    * {
      font-family: "NotoSansKR_L";
    }
    label {
      width: 100px;
      display: inline-block;
      &.tit {
        color: #2785ff;
      }
    }
    em {
      display: inline-block;
      padding-right: 18px;
      font-style: normal;
    }
  }
}
.email {
  padding-top: 30px;
  p {
    line-height: 220%;
    * {
      font-family: "NotoSansKR_L";
    }
    label {
      width: 100px;
      display: inline-block;
    }
  }
}
a.btn {
  font-size: 13px;
  color: #fff;
  line-height: 36px;
  border: 2px solid #0ea1a6;
  display: inline-block;
  border-radius: 20px;
  padding: 0 23px;
  position: absolute;
  left: 870px;
  top: 280px;
  background-color: #202737;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.02);
  cursor: pointer;
  z-index: 1;
}
.point {
  position: absolute;
  padding: 0 0 0 27px;
  left: 999px;
  top: 155px;
  font-family: "NotoSansKR_L";
  color: #0ea1a6;
  font-size: 14px !important;
  &::after {
    content: "";
    display: block;
    width: 16px;
    height: 16px;
    background-color: #0ea1a6;
    border-radius: 100%;
    position: absolute;
    left: 0;
    top: 8px;
  }
}
.point-2 {
  display: none;
  width: 100px;
  height: 100px;
  position: absolute;
  left: 955px;
  top: 121px;
  &::after {
    content: "";
    width: 100px;
    height: 100px;
    background-color: #0ea1a6;
    .abs-center;
    border-radius: 100%;
    opacity: 0.1;
    animation: play 0.8s infinite alternate;
  }
}
@keyframes play {
  from {
    width: 100px;
    height: 100px;
  }
  to {
    width: 90px;
    height: 90px;
  }
}
ul.location {
  position: absolute;
  left: 550px;
  top: 70px;
  font-family: "NotoSansKR_L";
  font-size: 12px;
  background-color: #1b1f27;
  padding: 20px 28px;
  display: none;
  li {
    line-height: 190%;
    span {
      color: #9043ff;
    }
  }
  &::after {
    content: "";
    width: 16px;
    height: 16px;
    position: absolute;
    bottom: -16px;
    left: 50%;
    background: url("~@/assets/arrow-1.png") no-repeat;
  }
}
.line {
  position: absolute;
  width: 452px;
  height: 300px;
  background: url("~@/assets/line-4.png") no-repeat;
  left: 556px;
  top: 153px;
  display: none;
}
.num {
  position: absolute;
  width: 20px;
  height: 20px;
  background: url("~@/assets/num-1.png") no-repeat;
  left: 684px;
  top: 441px;
}

.aboutus-container.active {
  .point-2,
  .location,
  .line {
    display: block;
  }
  a.btn {
    background-color: #0ea1a6;
  }
}

@media only screen and (max-width: 768px) {
  .aboutus-container {
    // background-color: #262c3e;
    // background: #262c3e url('~@/assets/map-1.png') no-repeat center;
    background-image: none;
  }
  .in-sec {
    width: 100%;
    height: auto;
    padding: 304px 0 50px 0;
  }
  h2 {
    font-size: 18px;
    padding: 50px 20px 11px 20px;
    &::after {
      width: 9px;
      height: 1px;
      left: 20px;
    }
  }
  .txt {
    font-size: 10px;
    padding: 7px 20px 0 20px;
  }
  .address {
    font-size: 10px;
    padding: 15px 20px;
    p {
      overflow: hidden;
      label {
        width: 88px;
        float: left;
      }
      span {
        float: left;
        width: calc(100% - 88px);
      }
    }
  }
  .email {
    font-size: 10px;
    padding: 3px 20px;
    p {
      label {
        width: 88px;
      }
    }
  }
  .aboutus-container.active {
    div.location {
      background: url("~@/assets/map-2-active.png") no-repeat;
      background-size: 100%;
    }
  }
  div.location {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 304px;
    background: url("~@/assets/map-2.png") no-repeat;
    background-size: 100%;
    a.btn {
      .abs-center;
      font-size: 10px;
      padding: 0 10px;
      line-height: 22px;
      border: 1px solid #0ea1a6;
    }
    ul.location {
      left: 10px;
      top: 10px;
      font-size: 10px;
      padding: 10px;
    }
  }
}
</style>

<template lang="pug">
  .aboutus-container(:class="{ active : isActive }")
    .in-sec
      h2 About Us
      .txt.
        클라이언트의 목적과 사용성을 먼저 생각하는 기본에서부터 출발합니다.#[br]
        비지니스의 확장을 생각하는 웹 토탈 서비스 그룹이며, 성공적이며 차별화된 비지니스 모델을 제시해 드립니다.#[br]
        확실한 핵심 역량과 끈기, 열정의 결과인 완벽한 솔루션으로 보답하겠습니다.
      .address
        p.
          #[label.tit (주)블루모바일]
          #[span #[em 사업자번호 : 220-87-28753] #[em 대표전화 : 02-554-9088] #[em 팩스 : 02-6354-9088]]
        p.
          #[label 지번]
          #[span 04784 서울특별시 성동구 성수동2가 322-1 3층 310호 (성수AK밸리)]
        p.
          #[label 도로명]
          #[span 04784 서울특별시 성동구 연무장길 76 3층 310호 (성수동2가, 성수AK밸리) (주)블루모바일]
      .email
        p.
          #[label 마케팅 담당]
          #[span blue@bluenmobile.com]
        p.
          #[label 차량관제 담당]
          #[span sckim@bluenmobile.com]
      //- .location
      //-   a.btn(@click="mapToggle") 오시는 길 안내
      //-   ul.location
      //-     li #[span A.] 6호선 망원역 1번 출구에서 우리은행을 지나 200m 직진
      //-     li #[span B.] 우회전하여 350m 직진 후 오른쪽 방향 Raise 빌딩 6층
      //-   .line
      //-   .num
      //-   .point Raise 빌딩#[br]6층
      //-   .point-2
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    mapToggle() {
      this.isActive = !this.isActive;
    },
  },
};
</script>
